module.exports = __webpack_public_path__ + "assets/media/lunch.23ac37e2.mp3";